import * as React from 'react'

import {
  isPipelinesEnabled,
  isPipelinesEnabledInExclusiveMode,
} from '../../../pages/PipelinesPages/utils/featureToggles'

import AgentsLink from './AgentsLink/AgentsLink'
import ChangesLink from './ChangesLink/ChangesLink'
import HomeLink from './HomeLink/HomeLink'
import PipelinesLink from './PipelinesLink/PipelinesLink'
import ProjectsLink from './ProjectsLink/ProjectsLink'
import QueueLink from './QueueLink/QueueLink'

function Links() {
  return (
    <React.Fragment>
      <HomeLink />

      {!isPipelinesEnabledInExclusiveMode && (
        <React.Fragment>
          <ProjectsLink />
          <ChangesLink />
          <AgentsLink />
          <QueueLink />
          {isPipelinesEnabled && <PipelinesLink />}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default React.memo(Links)
